import * as React from 'react';
import Page from '../../../components/Page';
import ProfileContainer from '../container/ProfileContainer';

const ProfilePage = () => (
  <Page header="profile">
    <ProfileContainer />
  </Page>
);

export default ProfilePage;
